module.exports = __webpack_public_path__ + "img/image-loader.3be970f8.gif";